import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

export const DemoResetCard = () => {
  const { user, reload } = useAuth();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!user.demo_resettable) return null;
  const reset = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/demo/reset");
      qc.clear();
      await reload();
      toast.success("Compte démo remis à zéro");
      navigate(`/configuration?space=${data.space}`, { replace: true });
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <section className="decision-strong space-y-3 p-5 sm:p-6" data-testid="demo-reset-card">
      <span className="badge-decision">Compte démo client</span>
      <h2 className="text-lg font-bold">Tout remettre à zéro</h2>
      <p className="text-sm text-muted-foreground">Efface les réponses de configuration, la banque simulée, les opérations, budgets, objectifs et demandes de devis de ce compte démo, puis relance l'accompagnement depuis le début.</p>
      <AlertDialog>
        <AlertDialogTrigger asChild><Button className="rounded-full bg-warning text-white hover:bg-warning/90" disabled={busy} data-testid="demo-reset-button"><RotateCcw className="mr-1 h-4 w-4" /> Remettre à zéro</Button></AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader><AlertDialogTitle>Remettre le compte démo à zéro ?</AlertDialogTitle>
            <AlertDialogDescription>Toutes les données de démonstration de ce compte seront effacées. Les autres comptes démo ne sont pas touchés.</AlertDialogDescription></AlertDialogHeader>
          <AlertDialogFooter><AlertDialogCancel data-testid="demo-reset-cancel">Annuler</AlertDialogCancel><AlertDialogAction onClick={reset} data-testid="demo-reset-confirm">Remettre à zéro</AlertDialogAction></AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
};
